import React from 'react';

// TODO: redesign: remove when discarding old design
export default React.createContext('');
